import { Avatar } from 'antd'
import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderAsanaCommon } from '../common'

export const ProviderAsanaClient: ProviderClient = {
  key: ProviderAsanaCommon.key,
  authentication: ProviderAuthenticationClient.Oauth2(
    ProviderAsanaCommon.authentication,
  ),

  description: {
    label: 'Asana',
    icon: (
      <Avatar
        size="small"
        src="https://cledara-public.s3.eu-west-2.amazonaws.com/Asana.png"
      />
    ),
    triggers: [
      {
        key: 'newTask',
        label: 'New task',
        output: [],
      },
    ],
    actions: [
      {
        key: 'createTaskInProject',
        label: 'Create task in a project',
        input: [{ key: 'name' }, { key: 'description' }, { key: 'projectId' }],
        output: [],
      },
    ],
  },
}
